import {WOW} from 'wowjs'

const wow = new WOW({
  boxClass: 'wow',
  animateClass: 'animated',
  offset: 0,
  live: false
});

wow.init()

